/* eslint-disable */
export default {
  to: 'À :',
  transferTo: 'Transférer à',
  blindTransfer: 'Transférer',
  warmTransfer: 'Demander d’abord',
  enterNameOrNumber: 'Saisir le numéro',
} as const;

// @key: @#@"to"@#@ @source: @#@"To:"@#@
// @key: @#@"transferTo"@#@ @source: @#@"Transfer to"@#@
// @key: @#@"blindTransfer"@#@ @source: @#@"Transfer"@#@
// @key: @#@"warmTransfer"@#@ @source: @#@"Ask first"@#@
// @key: @#@"enterNameOrNumber"@#@ @source: @#@"Enter Number"@#@
